import React from 'react'
import Link from 'gatsby-link'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import styles from './styles'

import Share from '../share'

import award_devops from '../../img/footer/award_devops.png'
import logo_msgold from '../../img/footer/cred_msgold.png'
import logo_27001 from '../../img/footer/cred_27001.png'
import logo_9001 from '../../img/footer/cred_9001.png'
import logo_essentials from '../../img/footer/cred_essentials.png'
import logo_tech100 from '../../img/footer/cred_tech100.jpg'
import phone from '../../img/icons/phone.svg'
import email from '../../img/icons/email.svg'
import twitter from '../../img/icons/twitter.svg'
import facebook from '../../img/icons/facebook.svg'
import linkedin from '../../img/icons/linkedin.svg'

const Footer = withStyles(styles)(props => {
  const { classes } = props

  return (
    <div className={classes.footer}>
      <div className={classes.contents}>
        <div className={classes.centred}>
          <Grid container spacing={16} className={classes.footerRow}>
            <Grid item xs={12}>
              <Typography variant="subheading">Website</Typography>
            </Grid>
            <Grid item xs={12} className={classes.footerRowLinks}>
              <Grid
                container
                spacing={0}
                className={classes.footerRow}
                alignItems={'flex-end'}
                direction={'row'}
                justify={'flex-start'}
              >
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/">Home</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/service/develop">Develop</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/service/dynamics_365">Dynamics</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/service/devops">Devops</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/service/datascience">Data Science</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/things">Products</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/blog">Blog</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/studies">Clients</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/careers">Careers</Link>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    <Link to="/about">About</Link>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.footerRow}>
            <Grid item xs={12}>
              <Typography variant="subheading">Contact</Typography>
            </Grid>
            <Grid item xs={12} className={classes.footerRowLinks}>
              <Grid
                container
                spacing={0}
                className={classes.footerRow}
                alignItems={'flex-end'}
                direction={'row'}
                // justify={'space-between'}
              >
                <Grid item className={classes.footerRowItem}>
                  <Typography variant="caption">
                    <img src={email} alt="Email" />
                    <a href="mailto:info@cloudthing.com">info@cloudthing.com</a>
                  </Typography>
                </Grid>
                <Grid item className={classes.footerRowItem}>
                  <Typography variant="caption">
                    <img src={email} alt="Email" />
                    <a href="mailto:careers@cloudthing.com">careers@cloudthing.com</a>
                  </Typography>
                </Grid>
                <Grid item className={classes.footerRowItem}>
                  <Typography variant="caption">
                    <img src={phone} alt="Telephone" />
                    <a href="tel:0121 393 4700">0121 393 4700</a>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.footerRow}>
            <Grid item xs={12}>
              <Typography variant="subheading">Credits</Typography>
            </Grid>
            <Grid item xs={12} className={classes.footerRowCreds}>
              <Grid
                container
                spacing={0}
                className={classes.footerRow}
                alignItems={'flex-end'}
                direction={'row'}
              >
                <Grid item>
                  <img src={logo_tech100} />
                </Grid>
                 <Grid item>
                  <img src={logo_msgold} />
                </Grid>
                <Grid item>
                  <img src={logo_9001} />
                </Grid>
                <Grid item>
                  <img src={logo_27001} />
                </Grid>
                <Grid item>
                  <img src={logo_essentials} />
                </Grid>
                <Grid item>
                  <img src={logo_essentials} />
                </Grid>
                <Grid item>
                  <img src={award_devops} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.footerRow}>
            <Grid item xs={12}>
              <Typography variant="subheading">Social</Typography>
            </Grid>
            <Grid item xs={12} className={classes.footerRowLinks}>
              <Grid
                container
                spacing={0}
                className={classes.footerRow}
                alignItems={'flex-end'}
                direction={'row'}
                // justify={'space-between'}
              >
                <Grid item>
                  <a
                    href="https://www.facebook.com/cloudthingmagic?_rdr"
                    target="_blank"
                  >
                    <img src={facebook} style={{ height: 40 }} />
                  </a>
                </Grid>
                <Grid item>
                  <a href="https://twitter.com/cloud_thing" target="_blank">
                    <img src={twitter} style={{ height: 40 }} />
                  </a>
                </Grid>
                <Grid item>
                  <a
                    href="https://www.linkedin.com/company/cloudthing"
                    target="_blank"
                  >
                    <img src={linkedin} style={{ height: 40 }} />
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={16} className={classes.footerRow}>
            <Grid item xs={12}>
              <Typography variant="subheading">Policy</Typography>
            </Grid>
            <Grid item xs={12} className={classes.footerRowLinks}>
              <Grid
                container
                spacing={0}
                className={classes.footerRow}
                alignItems={'flex-end'}
                direction={'row'}
              >

               <Grid item>
                  <Typography variant="caption">
                    <Link to="/policies">View All</Link>
                  </Typography>{' '}
                </Grid>
                  {
                props.policies && props.policies.map(({node})=><Grid item>
                <Typography variant="caption">
                  <Link to={`/policies/${node.uid}`} key={node.uid}>{node.data.title.text.split(" ")[0]}</Link>
                </Typography>{' '}
              </Grid> )
              }
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={40} className={classes.footerEnd}>
            <Grid item xs={12}>
              <Typography variant="caption">
                &copy; 2019 Copyright cloudThing ltd. All rights reserved.
                Company registered in England &amp; Wales no. 7510381, VAT no.
                152340739
              </Typography>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
})

export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/components/footer/index.js